/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bmi_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Under 18.5 is underweight, 18.5–24.9 is normal, 25–29.9 is overweight, and 30 or more is obese (for adults).`)
};

const es_bmi_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menos de 18,5 es bajo peso, 18,5–24,9 es normal, 25–29,9 es sobrepeso, y 30 o más es obeso (para adultos).`)
};

const de_bmi_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unter 18,5 ist Untergewicht, 18,5–24,9 ist normal, 25–29,9 ist Übergewicht, und 30 oder mehr ist Adipositas (für Erwachsene).`)
};

const nl_bmi_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onder 18,5 is ondergewicht, 18,5–24,9 is normaal, 25–29,9 is overgewicht, en 30 of meer is obees (voor volwassenen).`)
};

const fr_bmi_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moins de 18,5 est insuffisant, 18,5-24,9 est normal, 25-29,9 est surpoids, et 30 ou plus est obèse (pour les adultes).`)
};

const it_bmi_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sotto 18,5 è sottopeso, 18,5–24,9 è normale, 25–29,9 è sovrappeso, e 30 o più è obeso (per adulti).`)
};

const pt_br2_bmi_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abaixo de 18,5 é abaixo do peso, 18,5–24,9 é normal, 25–29,9 é acima do peso, e 30 ou mais é obeso (para adultos).`)
};

const pt_bmi_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menos de 18,5 é baixo peso, 18,5–24,9 é normal, 25–29,9 é excesso de peso, e 30 ou mais é obeso (para adultos).`)
};

const ja_bmi_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`18.5未満は低体重、18.5～24.9は普通体重、25～29.9は太り気味、30以上は肥満です（成人向け）。`)
};

const zh_bmi_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`低于 18.5 为偏瘦，18.5–24.9 为正常，25–29.9 为超重，30 及以上为肥胖（针对成年人）。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bmi_hub_faq2_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bmi_hub_faq2_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bmi_hub_faq2_a", locale)
	if (locale === "en") return en_bmi_hub_faq2_a(inputs)
	if (locale === "es") return es_bmi_hub_faq2_a(inputs)
	if (locale === "de") return de_bmi_hub_faq2_a(inputs)
	if (locale === "nl") return nl_bmi_hub_faq2_a(inputs)
	if (locale === "fr") return fr_bmi_hub_faq2_a(inputs)
	if (locale === "it") return it_bmi_hub_faq2_a(inputs)
	if (locale === "pt-BR") return pt_br2_bmi_hub_faq2_a(inputs)
	if (locale === "pt") return pt_bmi_hub_faq2_a(inputs)
	if (locale === "ja") return ja_bmi_hub_faq2_a(inputs)
	return zh_bmi_hub_faq2_a(inputs)
};